import React, { FC, useState } from 'react';
import {
  getTodoActionBtnLabel,
  todoAction,
  TodoActionsValues,
  useGetTodoAction,
} from 'components/posts/detail/overview/rightSection/beforeScheduleTodo/TodoItem.utils';
import QuickPostEditDateTime from 'components/posts/detail/overview/QuickPostEditDateTime';
import { addQueryParams, openBlank } from 'utils/url';
import { useOpenBillingPage } from 'app/hooks/useBillingUrl';
import { Alert } from '@kontentino/ui';
import { PostScheduleValidationMessage } from 'api/post';
import { useSocialLoginContext } from 'app/modules/socialLogin/context';
import { modalRoutes } from 'constants/routes';
import { PostDetail } from 'types/PostDetail';

type Props = {
  todo: PostScheduleValidationMessage;
  post: Pick<PostDetail, 'id' | 'date' | 'time' | 'page'> & {
    status: PostDetail['status'] | number;
  };
  type: 'danger' | 'warning';
  onDateTimeSave?: (values: { date: string; time: string | null }) => void;
};

const TodoItem: FC<Props> = ({ todo, post, type, onDateTimeSave }) => {
  const [activeAction, setActiveAction] = useState<TodoActionsValues | null>(
    null,
  );
  const action = useGetTodoAction(todo.message);
  const actionBtnLabel = getTodoActionBtnLabel(action);
  const socialLogin = useSocialLoginContext();
  const openBillingPage = useOpenBillingPage();

  function closeQuickAction() {
    setActiveAction(null);
  }

  function showQuickAction(action: TodoActionsValues) {
    switch (action) {
      case todoAction.choosePlan:
        openBillingPage('billing', { newTab: true });
        break;
      case todoAction.connectProfile:
        socialLogin.authorize({
          pageId: post.page.id,
          pageType: post.page.type,
          redirectUrl: `${addQueryParams(window.location.href, {
            id: post.id,
            type: post.page.type,
          })}/${modalRoutes.ASSOCIATE_POSTS_PROFILE}`,
        });
        break;
      case todoAction.learnAboutInstagramBusiness:
        openBlank(
          `https://intercom.help/kontentino/en/articles/6495363-how-to-fix-instagram-posts-publishing`,
        );
        break;
      default:
        setActiveAction(action);
        break;
    }
  }

  const shouldShowActionBtn =
    !!actionBtnLabel && action !== todoAction.noAction;

  return (
    <>
      <Alert
        variant={type}
        data-cy="post-schedule-validation-alert"
        cta={
          shouldShowActionBtn
            ? {
                label: actionBtnLabel,
                position: 'right',
                onClick: () => showQuickAction(action),
              }
            : undefined
        }
      >
        <span dangerouslySetInnerHTML={{ __html: todo.message }} />
      </Alert>
      <QuickPostEditDateTime
        open={
          activeAction === todoAction.editDateTime ||
          activeAction === todoAction.maintenance
        }
        onClose={closeQuickAction}
        post={post}
        onSave={onDateTimeSave}
      />
    </>
  );
};

export default TodoItem;
